import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'
import { IOptionsResponse } from '../../../common/common.types'
import { setOccupationOptions } from '../store/options.actions'
import { PatientDemographicsService } from '../../patientDemographics/services/patientDemographics.service'

export function* getOccupationOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const patientDemographicsService = new PatientDemographicsService(serviceId)
  try {
    const response: IOptionsResponse = yield call([
      patientDemographicsService,
      patientDemographicsService.getOccupationOptions,
    ])
    const { entity } = response
    yield put(setOccupationOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`getOccupationOptions() error: ${e}`))
  }
}

export function* getOccupationOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getOccupationOptions)
}
